<template>
  <div>
    <div class="text-center text-counter d-flex text-white justify-content-center align-items-center pb-2 counter-mobile" :class="mobile" v-if="mobile">
      <p class="counter text-black" v-if="currentTime">
        {{
          currentTime
              ? `${("0" + currentTime.hours).slice(-2)}:${(
                  "0" + currentTime.minutes
              ).slice(-2)}:${("0" + currentTime.seconds).slice(-2)}`
              : ""
        }}
      </p>
    </div>
    <div class="text-center text-counter counter-desktop" v-else>
      <p style="font-size: 16px;">Ofertas válidas por</p>
      <p class="counter text-black" v-if="currentTime">
        {{
          currentTime
              ? `${("0" + currentTime.hours).slice(-2)}:${(
                  "0" + currentTime.minutes
              ).slice(-2)}:${("0" + currentTime.seconds).slice(-2)}`
              : ""
        }}
      </p>
      <div class="d-flex justify-content-center text-center small">
        <div>Horas</div>
        <div>Minutos</div>
        <div>Segundos</div>
      </div>
      <hr>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    deadline: {
      type: String,
      required: true
    },
    speed: {
      type: Number,
      default: 1000
    },
    mobile: {
      type: Boolean
    },
  },
  data() {
    return {
      currentTime: null,
      isMobile: null
    };
  },
  mounted() {
    setTimeout(this.countdown, 1);
  },
  methods: {
    countdown() {
      let t = Date.parse(this.deadline) - Date.parse(new Date());
      let seconds = Math.floor((t / 1000) % 60);
      let minutes = Math.floor((t / 1000 / 60) % 60);
      let hours = Math.floor((t / (1000 * 60 * 60)) % 24);
      let days = Math.floor(t / (1000 * 60 * 60 * 24));

      if(days > 0){
        hours = hours + (days * 24);
      }
      
      if (t > 0) {
        this.currentTime = {
          total: t,
          days: days,
          hours: hours,
          minutes: minutes,
          seconds: seconds
        };
        let windowWidth = window.innerWidth;
        if(windowWidth < 480){
          this.isMobile = true;
        }else{
          this.isMobile = false;
        }
        setTimeout(this.countdown, this.speed);
      } else {
        this.currentTime = null;
      }
    }
  }
}
</script>
<style>
#app.liveshop .chat .counter-mobile.text-counter{
  display: none !important;
}
#app.liveshop.mobile .chat .counter-mobile.text-counter{
  display: flex !important;
}
#app .counter{
  display: block;
  font-size: 20px;
  font-weight: bolder;
  margin: 0;
}

#app.liveshop .text-counter{
  font-size: 20px;
  font-weight: bolder;
  margin: 0;
}
#app.liveshop .text-counter p{
  margin-left: 5px;
  margin: 0;
}
#app.liveshop .small div{
  margin: 0 4px;
  font-weight: bolder;
  font-size: 10px;
}
#app.liveshop .productos_list .counter{
  font-size: 30px;
  line-height: 30px;
}
#app.liveshop .counter-desktop hr{
  width: calc(100% - 20px);
  margin: 10px;
}
</style>